// Product groups shared across pages. Matched by Shopify handle first, then by title prefix,
// because Shopify titles can carry suffixes like "(REFLECTIVE)".

export const JEWELRY = [
  { name: "VVS1 Star Bracelet", handle: "vvs1-star-bracelet" },
  { name: "VVS1 Tennis Bracelet", handle: "untitled-jul21_19-03-01" },
  { name: "Tear Bracelet", handle: "tear-bracelet" },
  { name: "Angel Eyes Bracelet", handle: "angel-eyes-bracelet" },
];

export const MYSTERY_BOX = { name: "MYSTERY BOX", handle: "blackout-box-only-50" };

const matchesEntry = (product, entry) =>
  product?.id === entry.handle || (product?.name || "").toLowerCase().startsWith(entry.name.toLowerCase());

export const isJewelry = (product) =>
  JEWELRY.some((j) => matchesEntry(product, j)) || product?.category === "jewelry";

export const isMysteryBox = (product) => matchesEntry(product, MYSTERY_BOX);

// In-stock items that ship same day instead of being made to order.
export const shipsSameDay = (product) => isJewelry(product) || isMysteryBox(product);

// Pieces sold as a set. "Shop the set" on one piece shows the others (existing products only).
export const SETS = [
  { name: "Racer", handles: ["racer-jersey", "racer-longsleeve", "racer-track-pants"] },
];

// The other pieces of the product's set that the store actually has, in set order.
export const setPiecesFor = (product, allProducts = []) => {
  const set = SETS.find((s) => s.handles.includes(product?.id));
  if (!set) return [];
  return set.handles
    .filter((h) => h !== product.id)
    .map((h) => allProducts.find((p) => p.id === h))
    .filter(Boolean);
};
